import {Directive, ElementRef, EventEmitter, forwardRef, HostListener} from "@angular/core";
import {
  IInputCalendarComponentOptions,
  NInputCalendarPopoverComponent
} from "../components/n-input-calendar/n-input-calendar-popover/n-input-calendar-popover.component";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
// noinspection TypeScriptPreferShortImport
import {PopoverInstance, PopoverService} from "../n-popover/public_exports";

@Directive({
  selector: "[nDatePicker]",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NDatePickerDirective),
      multi: true
    }
  ],
})
export class NDatePickerDirective implements ControlValueAccessor {

  private popover: PopoverInstance<any>;
  private propagateChange: (_) => void;
  private date$ = new BehaviorSubject<Date>(undefined);

  constructor(private popoverSvc: PopoverService, private el: ElementRef) {

  }

  @HostListener("click")
  onClick() {
    const changeEmitter = new EventEmitter<Date>();

    changeEmitter.subscribe(date => {
      if (this.propagateChange) {
        this.propagateChange(date);
      }
      this.hidePopover();
    });

    const data: IInputCalendarComponentOptions = {
      change: changeEmitter,
      date$: this.date$,
      maxDate: null,
      minDate: null
    };

    this.popover = this.popoverSvc.open({
      componentType: NInputCalendarPopoverComponent,
      autoclose: true,
      popoverData: data,
      position: "bottom",
      targetElementRef: this.el
    });

    this.popover.onClose.subscribe(() => this.popover = null);
  }

  writeValue(obj: any): void {
    this.date$.next(obj);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  private async hidePopover() {
    if (!this.popover) {
      return;
    }
    await this.popover.done(undefined);
  }
}
